// hooks/useStoreReceipts.js
// import { useRecoilValue } from "recoil";
import useGroupedReceipts from "./useGroupedReceipts";

export const useStoreReceipts = () => {
  const stores = useGroupedReceipts();
  return { stores };
};
